export const dynamicSort = (keys) => (a, b) => {
  for (const key of keys) {
    if (typeof a[key] === "number") {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      if (a[key] === b[key]) continue;
    }
    const comparison = (a?.[key] || "")?.localeCompare(b?.[key] || "");
    if (comparison !== 0) return comparison;
  }
  return 0;
};
